// pages/sections/ClientBillingModal.js
// Last 12 months of billing for one client, month by month. Loaded on demand from
// /api/diClientData/{period}?billing=<ContIndex> (only clients you may see).
// "Billed" = invoices in the Practice Engine debtor ledger, before tax/surcharge.

import React from 'react';
import Modal from '../../components/Modal';
import { formatMoney, useFetchJson } from './clientDataUtil';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const money = n => formatMoney(n, { cents: true });

export default function ClientBillingModal({ period, row, onClose }) {
  const { data, error } = useFetchJson(`/api/diClientData/${period}?billing=${encodeURIComponent(row.contIndex)}`);

  const max = data ? Math.max(1, ...data.months.map(m => m.billed)) : 1;

  return (
    <Modal
      open
      onClose={onClose}
      title={`Billing — last 12 months — ${row.clientCode} ${row.clientName}`}
      footer={<button type="button" className="cd-btn cd-btn--ghost" onClick={onClose}>Close</button>}
    >
      {!data && !error && <p className="cd-modal-note">Loading billing…</p>}
      {error && <p className="cd-warn">Couldn&apos;t load billing: {error}</p>}
      {data && (
        <>
          <table className="cd-bill">
            <thead>
              <tr><th>Month</th><th className="cd-num">Invoices</th><th className="cd-num">Billed</th><th aria-hidden="true" /></tr>
            </thead>
            <tbody>
              {data.months.map((m, i) => (
                <tr key={m.key} className={m.billed ? '' : 'cd-bill-zero'}>
                  <td>{MONTHS[m.month - 1]} {m.year}{i === data.months.length - 1 ? <span className="cd-bill-mtd"> to date</span> : null}</td>
                  <td className="cd-num">{m.invoices || '—'}</td>
                  <td className="cd-num">{m.billed ? money(m.billed) : '—'}</td>
                  <td className="cd-bill-barcell">
                    {m.billed > 0 && <span className="cd-bill-bar" style={{ width: `${Math.max(2, Math.round((m.billed / max) * 100))}%` }} />}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr><td>Total</td><td className="cd-num">{data.invoices}</td><td className="cd-num">{money(data.total)}</td><td /></tr>
            </tfoot>
          </table>
          <p className="cd-modal-note cd-bill-note">
            Invoices from the Practice Engine debtor ledger, before tax and surcharge. Credit notes and write-offs aren&apos;t netted off,
            which matches the firm&apos;s trailing-12-month billing figure.
            {data.mirroredAt ? ` Data as of ${new Date(data.mirroredAt).toLocaleString()}.` : ''}
          </p>
        </>
      )}
    </Modal>
  );
}
